import React from 'react';

const Ec2ExColumnsControlPanel = ({header, toggleColumnVisibility, swapColumnOrder, sortColumn}) => {

  const handleClick = e => {
    if (e.target.value === 'X') toggleColumnVisibility(header.title);
    else if (e.target.value === '<' || e.target.value === '>') {
      swapColumnOrder(header.title, e.target.value === '<' ? -1 : 1);
    } else if (e.target.value === '^' || e.target.value === 'v') {
      sortColumn(header.title, e.target.value === '^' ? 1 : -1);
    }
  };

  return (
    <th key={`${header.title}-controls`} className="ColumnControls StickyRowTop">
      <div className="ColumnControls">
        <button value={'<'} onClick={handleClick} className="Ec2ExDir">{'<'}</button>
        <button value={'^'} onClick={handleClick} className="Ec2ExDir">{'^'}</button>
        <button value={'X'} onClick={handleClick} className="Ec2ExDel">{'X'}</button>
        <button value={'v'} onClick={handleClick} className="Ec2ExDir">{'v'}</button>
        <button value={'>'} onClick={handleClick} className="Ec2ExDir">{'>'}</button>
      </div>
    </th>
  );

};

export default Ec2ExColumnsControlPanel;


// WEBPACK FOOTER //
// ./src/components/content/ec2Explorer/ec2ExMain/ec2ExColumnControlPanel/ec2ExColumnControlPanel.js